import React from "react";
import { OutputDestinationsGrid } from "./Components/OutputDestinationsGrid";

function OutputDestinations() {
  return <OutputDestinationsGrid/>
}
export { OutputDestinations };
